let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jTy4m")).then(() => parcelRequire('j5rio'));